import {Component, Inject,  OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FileInput, FileInputComponent, FileValidator} from "ngx-material-file-input";
import {delay, first, takeUntil} from "rxjs/operators";
import {Uuid} from "../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {Dictionary} from "../../../shared/interface/dictionary";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {DOCUMENT} from "@angular/common";
import {ReplaySubject} from "rxjs";
import {AddressImport} from "../../../shared/interface/address-import";
import {AddressImportService} from "../../../shared/services/address-import.service";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-address-import',
  templateUrl: './address-import.component.html',
  styleUrls: ['./address-import.component.scss']
})
export class AddressImportComponent implements OnInit, OnDestroy {

  @ViewChild('fileInput') fileInputComponent: FileInputComponent;

  importCompanyId: ReplaySubject<number> = new ReplaySubject<number>(1);
  addressImportFormValid = false;
  addressImportForm: FormGroup;
  fileControl: FormControl;

  typeKeys: string[] = [];
  fileMaxSize = 52428800;
  selectedTypes: Dictionary[] = [];
  processingRequest = false;
  formErrors = {};
  addressImport?: AddressImport;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private addressImportService: AddressImportService,
    public dialogRef: MatDialogRef<AddressImportComponent>,
    @Inject(DOCUMENT) private document: Document) {
    this.addressImportForm = fb.group({
      streetImport: fb.control(false),
      fileContent: fb.control('', [Validators.required]),
      fileName: fb.control('', [Validators.required]),
      file: this.fileControl = fb.control('', [Validators.required, FileValidator.maxContentSize(this.fileMaxSize)]),
    });

  }

  ngOnInit(): void {
    this.addressImportForm.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      )
      .subscribe(() => {
        this.addressImportFormValid = this.addressImportForm.valid;
      });

    this.fileControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((file: FileInput) => {
        if (!file || file.files.length === 0) {
          this.addressImportForm.get('fileContent').setValue('');
          this.addressImportForm.get('fileName').setValue('');
          return;
        }
        file.files.forEach((fileToRead: File) => {
          const reader = new FileReader();
          reader.readAsDataURL(fileToRead);
          reader.onload = () => {
            this.addressImportForm.get('fileName').setValue(fileToRead.name);
            this.addressImportForm.get('fileContent').setValue(/base64,(.+)/.exec(reader.result.toString())[1]);
          };
        });
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onTypesChange(dicts: Dictionary[]): void {
    this.selectedTypes = dicts;
  }

  loadImport(importId: string): void {
    this.addressImportService.getImport(importId)
      .pipe(delay(1000))
      .subscribe((addressImport: AddressImport) => {
        this.addressImport = addressImport;

        if (addressImport.progress !== 100) {
          this.loadImport(addressImport.uuid);
        } else {
          this.snack.open('Import zakończony prawidłowo', '', {
            duration: 2000,
          });
        }
      });
  }

  import(): void {
    if (!this.addressImportForm.valid) {
      this.addressImportForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.addressImportForm, this.formErrors);
    this.formErrors = {};

    this.addressImportService.import(this.addressImportForm.value)
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snack.open('Rozpoczynanie importowania', '', {
          duration: 2000,
        });
        this.dialogRef.close();
        this.processingRequest = false;
        this.loadImport(response.uuid);
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snack.open('Podczas importu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.addressImportForm, this.formErrors);
        }
      })
    ;
  }

  resetFileValue(): void {
    this.fileControl.setValue('');
    this.fileInputComponent.clear();
  }
  cancel(e): void {
    this.dialogRef.close(e);
    return;
  }
}
